<div class="tabs-container">
  <nav>
    <ul class="flex">
      <li
        *ngFor="let tab of tabs"
        class="tab"
        [ngClass]="{ active: tab.active === true }"
        (click)="selectTab(tab)"
      >
        {{ tab.tabTitle }}
      </li>
    </ul>
  </nav>
  <article>
    <ng-content></ng-content>
  </article>
</div>
